var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAltaisStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.73 15.639c-5.137-1.164-9.15-5.22-10.354-10.358-.04-.2-.2-.281-.361-.281-.16 0-.321.08-.361.281C14.49 10.42 10.437 14.434 5.3 15.639c-.401.08-.401.602 0 .722 5.136 1.164 9.15 5.22 10.353 10.358.04.2.2.281.361.281.16 0 .321-.08.361-.281 1.164-5.139 5.217-9.153 10.353-10.358.361-.12.361-.642 0-.722zm-10.715 4.336A16.972 16.972 0 0 0 12.042 16a16.972 16.972 0 0 0 3.973-3.974A16.974 16.974 0 0 0 19.988 16a16.974 16.974 0 0 0-3.973 3.974z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltaisStar);
export default __webpack_public_path__ + "static/media/Altais-Star.bd33f29539e0988b8f6a315cdf470b1c.svg";
export { ForwardRef as ReactComponent };